// Global shim for legacy libraries that expect globals (jQuery, angular, underscore)
// Vite bundles as ESM which doesn't set window globals automatically.
// This file must be imported BEFORE any library that depends on these globals.

import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

import angular from 'angular'
window.angular = angular

import _ from 'underscore'
window._ = _
